// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"64aababc","537":"09d2fac0"}[chunkId] + ".chunk.js";
};